import React from "react";
import { Link } from "react-router-dom";
import "../css/policy.scss";

export const POLICY_UPDATED = "16 October 2026";

export function PolicySection({ title, children }) {
  return (
    <section className="policy-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}

export function PolicyContact({ subject = "this policy" }) {
  return (
    <PolicySection title="Contact">
      <p>
        Questions about {subject} can be sent to{" "}
        <a href="mailto:gear@mefurvexo.monster">gear@mefurvexo.monster</a>.
        Please include an order number when your request concerns a purchase.
      </p>
      <address>
        mefurvexo
        <br />
        CUPFORD HOUSE
        <br />
        QUEEN&apos;S ROAD WEST 108
        <br />
        CENTRAL AND WESTERN DISTRICT
        <br />
        HONG KONG
      </address>
    </PolicySection>
  );
}

function PolicyLayout({ title, intro, children, contactSubject, showContact = true }) {
  return (
    <main className="policy-page">
      <article className="policy-content">
        <header className="policy-header">
          <p className="policy-eyebrow">MEFURVEXO POLICY</p>
          <h1>{title}</h1>
          <p className="policy-updated">Last updated: {POLICY_UPDATED}</p>
          {intro && <p className="policy-intro">{intro}</p>}
        </header>
        {children}
        {showContact && <PolicyContact subject={contactSubject || title.toLowerCase()} />}
        <nav className="policy-back" aria-label="Policy navigation">
          <Link to="/policies">View all store policies</Link>
        </nav>
      </article>
    </main>
  );
}

export default PolicyLayout;
